import * as React from "react";

// import { IFancyDropdownOption } from "../../classes/fancyDropdownOption";
import { IOption } from "../../classes/option";
import { ISearchToolbarState } from "../../classes/state";
import { IText } from "../../classes/text";

import { Button } from "../Common/Button/Button";
import { FancyDropdown, FancyDropdownAlignment, FancyDropdownMode } from "../Common/FancyDropdown/FancyDropdown";
import { SearchTextTextbox } from "./SearchTextTextbox";

import { IFancyDropdownOptionProps } from "../common/FancyDropdown/FancyDropdownOption";

export interface ISearchToolbarProps {
  filterOptions: IOption[];
  categoryOptions: IOption[];
  searchText: string;
  filterSelectedValue: string;
  categorySelectedValue: string;
  text: IText;
  portletInstanceId: number;
  onChangeSearchText: (event: any) => any;
  onResetSearchSettings: (event: any) => any;
  onRunSearch: (event: any) => any;
  onFilterItemSelected: (event: any) => any;
  onCategoryItemSelected: (event: any) => any;
}

const getLocalDropdownOptions = (optionsFromProps: IOption[], onSelected: (event: any) => any, defaultFilterOptionText: string): IFancyDropdownOptionProps[] => {
  // Filter dropdown options: Create local collection of fancydropdown options based on options passed in from props, and add the isSelected=false and onFilter/Category/ItemSelected event handler to each option.
  const localfilterOptions: IFancyDropdownOptionProps[] = [];
  optionsFromProps.map((option) => {
    const newOption: IFancyDropdownOptionProps = Object.assign({}, option);
    newOption.isSelected = false;
    newOption.onSelected = onSelected;
    localfilterOptions.push(newOption);
  });
  addDefaultOption(localfilterOptions, defaultFilterOptionText, onSelected);

  return localfilterOptions;
};

const addDefaultOption = (options: IFancyDropdownOptionProps[], defaultText: string, onSelected: (event: any) => any): IFancyDropdownOptionProps[] => {
  const defaultOption: IFancyDropdownOptionProps = { text: defaultText, value: "", isSelected: true, onSelected };
  options.unshift(defaultOption);
  return options;
};

export class SearchToolbar extends React.Component<ISearchToolbarProps, any> {

  public constructor(props: any, context: any) {
    super(props, context);

    let tabIndexedItemID = null;
    if (this.props.filterOptions.length > 0) {
      tabIndexedItemID = "filterdropdown_" + this.props.portletInstanceId;
    } else if (this.props.categoryOptions.length > 0) {
      tabIndexedItemID = "categorydropdown_" + this.props.portletInstanceId;
    }
    this.state = { tabIndexedItemID };

    this.onFocussed = this.onFocussed.bind(this);
  }

  public onFocussed = (itemID: string): void => {
    this.setState({ tabIndexedItemID: itemID });
  }

  public render() {

    const props = this.props;

    if (props.filterOptions.length > 0 || props.categoryOptions.length > 0) {

      const text = props.text;

      const localfilterOptions = getLocalDropdownOptions(props.filterOptions, props.onFilterItemSelected, text.searchToolbar.defaultFilterOption);
      const localCategoryOptions = getLocalDropdownOptions(props.categoryOptions, props.onCategoryItemSelected, text.searchToolbar.defaultCategoryOption);

      const liClassDropdown = "CLA-dropdownWrapper ";
      const liClass = "js-nav-system__item";

      const filterdropdownID = "filterdropdown_" + props.portletInstanceId;
      const searchtextboxID = "searchtextbox_" + props.portletInstanceId;
      const categorydropdownID = "categorydropdown_" + props.portletInstanceId;
      const searchbuttonID = "searchbutton_" + props.portletInstanceId;
      const clearsearchbuttonID = "clearsearchbutton_" + props.portletInstanceId;

      const tooltipText = props.text.mainToolbar.useArrowKeysToNavigateThroughOptions;

      let filterTooltip = null;
      if (props.filterOptions.length > 0) { filterTooltip = tooltipText; }

      let categoryOptionsTooltip = null;
      if (props.categoryOptions.length > 0 && filterTooltip == null) { categoryOptionsTooltip = tooltipText; }

      return (
        <div className="CAL-search" role="toolbar" aria-label="Search toolbar">
          <ul className="js-nav-system">

            {props.filterOptions.length > 0 &&
              <li className={liClassDropdown + liClass} role="menu">
                <FancyDropdown
                  itemID={filterdropdownID}
                  defaultText={text.searchToolbar.defaultFilterPrompt}
                  mode={FancyDropdownMode.textButton}
                  options={localfilterOptions}
                  selectedValue={props.filterSelectedValue}
                  tabIndex={this.setTabIndex(filterdropdownID)}
                  toolTip={filterTooltip}
                  onFocussed={this.onFocussed}
                />
              </li>
            }

            {props.filterOptions.length > 0 &&
              <li className={liClass} role="textbox">
                <SearchTextTextbox
                  itemID={searchtextboxID}
                  searchText={props.searchText}
                  labelText={text.searchToolbar.searchText_placeholder}
                  onChange={props.onChangeSearchText}
                  tabIndex={this.setTabIndex(searchtextboxID)}
                  onFocussed={this.onFocussed}
                />
              </li>
            }

            {props.categoryOptions.length > 0 &&
              <li className={liClassDropdown + liClass} role="menu">
                <FancyDropdown
                  itemID={categorydropdownID}
                  alignment={FancyDropdownAlignment.right}
                  defaultText={text.searchToolbar.defaultCategoryPrompt}
                  mode={FancyDropdownMode.textButton}
                  options={localCategoryOptions}
                  selectedValue={props.categorySelectedValue}
                  tabIndex={this.setTabIndex(categorydropdownID)}
                  toolTip={categoryOptionsTooltip}
                  onFocussed={this.onFocussed}
                />
              </li>
            }

            <li className={liClass} role="button">
              <Button
                itemID={searchbuttonID}
                cssID="searchButton"
                text={text.searchToolbar.searchButton}
                fontawesomeIconCSS="fa-search"
                onClick={props.onRunSearch}
                disabled={false}
                tabIndex={this.setTabIndex(searchbuttonID)}
                onFocussed={this.onFocussed}
              />
            </li>

            <li className={liClass} role="button">
              <Button
                itemID={clearsearchbuttonID}
                cssID="clearSearchButton"
                text={text.searchToolbar.clearSearchButton}
                fontawesomeIconCSS="fa-times"
                onClick={props.onResetSearchSettings}
                disabled={false}
                tabIndex={this.setTabIndex(clearsearchbuttonID)}
                onFocussed={this.onFocussed}
              />
            </li>

          </ul>
        </div>
      );
    }

    return null;
  }

  private setTabIndex = (itemID: string): number => {
    if (this.state && this.state.tabIndexedItemID) {
      return itemID === this.state.tabIndexedItemID ? 0 : -1;
    }
    return 0;
  }

};
